import type React from 'react';

export const getContainer = (ref: React.RefObject<HTMLDivElement>): HTMLElement => {
  if (ref.current) {
    return ref.current;
  }

  return document.body;
};
